var map = {
	"./1.mp3": "8b91",
	"./10.mp3": "f88a",
	"./100.mp3": "b841",
	"./101.mp3": "6add",
	"./102.mp3": "4f76",
	"./11.mp3": "4123",
	"./12.mp3": "31e6",
	"./13.mp3": "4320",
	"./14.mp3": "db67",
	"./15.mp3": "ec22",
	"./16.mp3": "787c",
	"./17.mp3": "1f12",
	"./18.mp3": "f00c",
	"./19.mp3": "64ca",
	"./2.mp3": "a536",
	"./20.mp3": "6703",
	"./21.mp3": "9317",
	"./22.mp3": "2481",
	"./23.mp3": "16d3",
	"./24.mp3": "27de",
	"./25.mp3": "dc19",
	"./26.mp3": "6782",
	"./27.mp3": "1485",
	"./28.mp3": "7dc2",
	"./29.mp3": "3bfe",
	"./3.mp3": "7c8b",
	"./30.mp3": "318b",
	"./31.mp3": "0c34",
	"./32.mp3": "242a",
	"./33.mp3": "62b6",
	"./34.mp3": "8f7f",
	"./35.mp3": "9e01",
	"./36.mp3": "2073",
	"./37.mp3": "ff3b",
	"./38.mp3": "0814",
	"./39.mp3": "09f4",
	"./4.mp3": "cb7a",
	"./40.mp3": "f64c",
	"./41.mp3": "80dc",
	"./42.mp3": "0451",
	"./43.mp3": "08ca",
	"./44.mp3": "1c4b",
	"./45.mp3": "f65d",
	"./46.mp3": "a726",
	"./47.mp3": "d99a",
	"./48.mp3": "4267",
	"./49.mp3": "0293",
	"./5.mp3": "a4d5",
	"./50.mp3": "954b",
	"./51.mp3": "0b67",
	"./52.mp3": "84f8",
	"./53.mp3": "3d7a",
	"./54.mp3": "a366",
	"./55.mp3": "3e1c",
	"./56.mp3": "5e27",
	"./57.mp3": "4e6c",
	"./58.mp3": "8208",
	"./59.mp3": "09dd",
	"./6.mp3": "ce85",
	"./60.mp3": "dbb7",
	"./61.mp3": "4151",
	"./62.mp3": "18d5",
	"./63.mp3": "9ed34",
	"./64.mp3": "1b24",
	"./65.mp3": "26e8",
	"./66.mp3": "7379",
	"./67.mp3": "313a",
	"./68.mp3": "c50b",
	"./69.mp3": "05f0",
	"./7.mp3": "940f",
	"./70.mp3": "d16a",
	"./71.mp3": "38f0",
	"./72.mp3": "31ca",
	"./73.mp3": "0540",
	"./74.mp3": "9a3e",
	"./75.mp3": "03f3",
	"./76.mp3": "4064",
	"./77.mp3": "cd61",
	"./78.mp3": "c1aa",
	"./79.mp3": "9ee3",
	"./8.mp3": "8ec4",
	"./80.mp3": "3501",
	"./81.mp3": "e751",
	"./82.mp3": "c845",
	"./83.mp3": "a485",
	"./84.mp3": "7cf4",
	"./85.mp3": "210e",
	"./86.mp3": "9cf5",
	"./87.mp3": "a764",
	"./88.mp3": "7289",
	"./89.mp3": "47d3",
	"./9.mp3": "c4a8",
	"./90.mp3": "964e",
	"./91.mp3": "9938",
	"./92.mp3": "bf5c",
	"./93.mp3": "d1a9",
	"./94.mp3": "33c3",
	"./95.mp3": "dea5",
	"./96.mp3": "5424",
	"./97.mp3": "8ec7",
	"./98.mp3": "1769",
	"./99.mp3": "2970"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9342";